/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Snigdha <snigdha.dhanireddy@mroads.com>, August 2020
 * @format
 * @flow
 */

import { ActionTypes } from '../constants';
import {
  TableReceiptPrint,
} from '../sagas/table-saga';


export function tableReceipt(payload: TableReceiptPrint) {
  return {
    type: ActionTypes.TABLE_RECEIPT_PRINT_REQUEST,
    payload,
  };
}